var getip;
jQuery.get("https://ipinfo.io/json", function(response) {
    getip = response.ip;
	var geturl_data= "https://ipapi.co/"+getip+"/json/";

	jQuery.getJSON(geturl_data, function(data){

        if(data.country == 'AU'){
            jQuery("#pop_country li[value='Australia']").addClass('selected');
        } else if(data.country == 'NZ'){
            jQuery("#pop_country li[value='New Zealand']").addClass('selected');
        } else if(data.country == 'CN'){
            jQuery("#pop_country li[value='China']").addClass('selected');
        } else {
          if(data.continent_code == 'NA'){
                jQuery("#pop_country li[value='North America']").addClass('selected');
          } else if(data.continent_code == 'EU'){
                jQuery("#pop_country li[value='Europe']").addClass('selected');
          } else {
                jQuery("#pop_country li[value='Rest of World']").addClass('selected');
          }
        }
       jQuery(".popup-select-lable").text(jQuery("#pop_country li.selected").text()); 
    });
  
}, "jsonp");